<template>
    <svg
        version="1.1"
        id="Laag_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 230.8 251"
        style="enable-background: new 0 0 230.8 251"
        xml:space="preserve"
    >
        <path :fill="color" d="M9.7,95.1l53.9-23.2v139.5c-6-6.5-11.5-13.4-16.5-20.7C27.6,162,14.8,129.3,9.7,95.1z" />
        <path
            :fill="color"
            d="M138.9,58.8c-4.6-1.7-22.6-6.2-37.7,0.7c-16.7,7.8-16.8,13.6-16.8,24.8v130.5c0,8.3,3.4,18.8,7.6,22.3
	c4.3,3.5,20.7,13.4,23.2,13.8c5.3-1,41.5-21.6,68-60.3c19.4-28.4,32.2-60.9,37.3-94.9C220.6,95.8,143.5,60.6,138.9,58.8z M129,148.6
	c-7.1,0-12.8-5.7-12.8-12.8c0-7.1,5.7-12.8,12.8-12.8c7.1,0,12.8,5.7,12.8,12.8l0,0c0,7-5.7,12.8-12.7,12.8
	C129.1,148.6,129,148.6,129,148.6z"
        />
        <path :fill="color"
            d="M222.6,43.6c0-2.1-1.2-4.1-3.2-4.9L205.1,32V11.8c0-3.9-3.2-7.1-7.2-7.1h-17.4c-3.9,0-7.1,3.2-7.2,7.1v5.5
	l-20.9-9.7h-0.1c-22.2-10-47.7-10.2-70.1-0.5L10.2,39.8c-1.2,0.5-1.9,1.7-1.9,3L8.1,74.9l87.2-38c14-6,29.8-5.9,43.7,0.3l83.9,38.5
	L222.6,43.6z"
        />
    </svg>
</template>

<script>
export default {
    props: {
        color: String,
    },
};
</script>